import * as actions from './relatorios.action';
import inicialState from './relatorios.state';

const relatoriosReducer = (state = inicialState, action) => {
  switch (action.type) {
      case actions.DESCARTE_RELATORIOS_ATUALIZAR_DATA_INICIO:
      return {
        ...state,
        dataInicio: action.payload.dataInicio,
      };
    case actions.DESCARTE_RELATORIOS_ATUALIZAR_DATA_FIM:
      return {
        ...state,
        dataFim: action.payload.dataFim,
      };
    case actions.DESCARTE_RELATORIOS_ATUALIZAR_FILTRO_VALUE:
      return {
        ...state,
        filtroValue: action.payload.filtroValue,
      };
    case actions.DESCARTE_RELATORIOS_ATUALIZAR_LISTA:
      return {
        ...state,
        lista: action.payload.lista,
      };
   
    case actions.DESCARTE_RELATORIOS_ATUALIZAR_TIPO:
      return {
        ...state,
        tipo: action.payload.tipo,
      };
   
    case actions.DESCARTE_RELATORIOS_ATUALIZAR_IMPRIMIR:
      return {
        ...state,
        imprimir: action.payload.imprimir,
      };
   
    default:
      return state;
  }
};

export default relatoriosReducer;



// WEBPACK FOOTER //
// ./src/pages/descarte/tabs/relatorios/store/relatorios.reducer.js